<ion-grid>
	<ion-row>
		<!-- <ion-col size="auto">
			<ion-card
				color="primary"
				class="cursor-pointer"
				*ngIf="pagesService.getPermissionByName('hubble_community')| async"
				[routerLink]="['community']"
			>
				<ion-card-header>
					Hubble Community
				</ion-card-header>
			</ion-card>
			<ion-ripple-effect></ion-ripple-effect>
		</ion-col> -->
		<ion-col size="auto">
			<ion-card
				color="secondary"
				class="cursor-pointer"
				*ngIf="pagesService.getPermissionByName('hubble_events')| async"
				[routerLink]="['events']"
			>
				<ion-card-header>
					Hubble Events
				</ion-card-header>
			</ion-card>
			<ion-ripple-effect></ion-ripple-effect>
		</ion-col>
	</ion-row>
</ion-grid>
